import { ActionKeys } from "../_actions/constants/chapterConstants";
import toastr from "toastr";

const initialState = {
  isError: false,
  isSuccess: true,
  errorMessage: null,
  helpTexts: null,
  total: 0,
  fiscalYear: null,
  chapterRanges: null,
  memberCounts: null,
  reports: [],
  totalReports: 0,
  totalMemberCounts: 0,
  chapterList: null,
  activeChapter: null,
  chapterBudgets: null,
  chapterBudgetsLength: 0,
  activeChapterBudget: null,
  chapterFinancials: null,
  activeChapterFinancial: null,
  chapterFinancialsDefaults: null,
  isFetching: {},
  isFetched: {},
  isUpdating: {}
};

export default function chapterReducer(state, action) {
  state = state || initialState;
  const { isFetched, isFetching, isUpdating } = state;

  switch (action.type) {
    case ActionKeys.REQUEST_HELP_TEXT:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          HELP_TEXT: true
        },
        isFetched: {
          ...isFetched,
          HELP_TEXT: false
        }
      };
      break;
    case ActionKeys.RECEIVE_HELP_TEXT:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          HELP_TEXT: false
        },
        isFetched: {
          ...isFetched,
          HELP_TEXT: true
        }
      };
      break;
    case ActionKeys.RESET_IS_FETCHED:
      state = {
        ...state,
        isFetched: {},
        activeChapterFinancial: null,
        activeChapterBudget: null,
        activeChapter: null
      };
      break;
    case ActionKeys.RESET_ACTIVE_CHAPTER_BUDGET:
      state = {
        ...state,
        activeChapterBudget: null
      };
      break;
    case ActionKeys.REQUEST_MEMBER_COUNTS:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          MEMBER_COUNTS: true
        },
        isFetched: {
          ...isFetched,
          MEMBER_COUNTS: false
        }
      };
      break;
    case ActionKeys.RECEIVE_MEMBER_COUNTS:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          MEMBER_COUNTS: false
        },
        isFetched: {
          ...isFetched,
          MEMBER_COUNTS: true
        }
      };
      break;
    case ActionKeys.CREATE_MEMBER_COUNT:
      state = {
        ...state,
        ...action
      };
      if (action.isSuccess) {
        toastr.success("Created chapter member count successfully");
      }
      break;
    case ActionKeys.UPDATE_MEMBER_COUNT:
      state = {
        ...state,
        ...action
      };
      if (action.isSuccess) {
        toastr.success("Updated chapter member count successfully");
      }
      break;
    case ActionKeys.REQUEST_CHAPTER_FINANCIALS:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIALS: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIALS: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_FINANCIALS:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIALS: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIALS: true
        }
      };
      break;
    case ActionKeys.REQUEST_CHAPTER_SUMMARY_REPORT:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_SUMMARY: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_SUMMARY: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_SUMMARY_REPORT:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_SUMMARY: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_SUMMARY: true
        }
      };
      break;

    case ActionKeys.REQUEST_CHAPTER_FINANCIAL:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIAL: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIAL: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_FINANCIAL:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIAL: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIAL: true
        }
      };
      break;
    case ActionKeys.REQUEST_CHAPTER_BUDGETS:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_BUDGETS: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_BUDGETS: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_BUDGETS:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_BUDGETS: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_BUDGETS: true
        }
      };
      break;
    case ActionKeys.REQUEST_CHAPTER_BUDGET:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_BUDGET: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_BUDGET: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_BUDGET:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_BUDGET: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_BUDGET: true
        }
      };
      break;
    case ActionKeys.CREATE_CHAPTER_BUDGET_STARTED:
    case ActionKeys.UPDATE_CHAPTER_BUDGET_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true,
        isUpdating: {
          ...isUpdating,
          CHAPTER_BUDGET: true
        }
      };
      break;
    case ActionKeys.CREATE_CHAPTER_BUDGET_FINISHED:
    case ActionKeys.UPDATE_CHAPTER_BUDGET_FINISHED:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          CHAPTER_BUDGET: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_BUDGETS: false
        }
      };
      break;
    case ActionKeys.UPDATE_CHAPTER_BUDGET_FILE_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true,
        isUpdating: {
          ...isUpdating,
          CHAPTER_BUDGET_FILE: true
        }
      };
      break;
    case ActionKeys.UPDATE_CHAPTER_BUDGET_FILE_FINISHED:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          CHAPTER_BUDGET_FILE: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_BUDGET_FILE: false
        }
      };
      break;
    case ActionKeys.REQUEST_CHAPTER_FINANCIALS_DEFAULTS:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIALS_DEFAULTS: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIALS_DEFAULTS: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_FINANCIALS_DEFAULTS:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIALS_DEFAULTS: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIALS_DEFAULTS: true
        }
      };
      break;
    case ActionKeys.CREATE_REPORT_ITEM_STARTED:
    case ActionKeys.UPDATE_REPORT_ITEM_STARTED:
    case ActionKeys.REMOVE_REPORT_ITEM_STARTED:
    case ActionKeys.UPDATE_REPORT_ITEMS_STARTED:
    case ActionKeys.INITIAL_REPORT_ITEMS_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true,
        isUpdating: {
          ...isUpdating,
          REPORT_ITEM: true
        }
      };
      break;
    case ActionKeys.CREATE_REPORT_ITEM_FINISHED:
    case ActionKeys.UPDATE_REPORT_ITEM_FINISHED:
    case ActionKeys.UPDATE_REPORT_ITEMS_FINISHED:
    case ActionKeys.INITIAL_REPORT_ITEMS_FINISHED:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          REPORT_ITEM: false
        },
        isFetched: {
          ...isFetched,
          REPORT_ITEM: false
        }
      };
      if (action.isSuccess) {
        toastr.success("Updated report successfully");
      }
      break;
    case ActionKeys.UPDATE_REPORT_W2_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true,
        isUpdating: {
          ...isUpdating,
          REPORT_W2: true
        }
      };
      break;
    case ActionKeys.UPDATE_REPORT_W2_FINISHED:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          REPORT_W2: false
        },
        isFetched: {
          ...isFetched,
          REPORT_W2: false
        }
      };
      if (action.isSuccess) {
        toastr.success("Updated report W2/1099 successfully");
      }
      break;
    case ActionKeys.UPDATE_REPORT_VOTING_COUNT_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true,
        isUpdating: {
          ...isUpdating,
          REPORT_VOTING_COUNT: true
        }
      };
      break;
    case ActionKeys.UPDATE_REPORT_VOTING_COUNT_FINISHED:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          REPORT_VOTING_COUNT: false
        },
        isFetched: {
          ...isFetched,
          REPORT_VOTING_COUNT: false
        }
      };
      if (action.isSuccess) {
        toastr.success("Updated voting information successfully");
      }
      break;
    case ActionKeys.SUBMIT_CHAPTER_FINANCIAL_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true,
        isUpdating: {
          ...isUpdating,
          SUBMIT_CHAPTER_FINANCIAL: true
        }
      };
      break;
    case ActionKeys.SUBMIT_CHAPTER_FINANCIAL_FINISHED:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          SUBMIT_CHAPTER_FINANCIAL: false
        },
        isFetched: {
          ...isFetched,
          SUBMIT_CHAPTER_FINANCIAL: false
        }
      };
      if (action.isSuccess) {
        toastr.success("The chapter financial is submitted successfully.");
      }
      break;
    case ActionKeys.REQUEST_CHAPTER_ANALYSIS_REPORTS:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_ANALYSIS_REPORTS: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_ANALYSIS_REPORTS: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_ANALYSIS_REPORTS:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_ANALYSIS_REPORTS: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_ANALYSIS_REPORTS: true
        }
      };
      break;

    default:
      return { ...state };
  }

  if (state.isError) {
    toastr.error(state.errorMessage);
  } else if (!state.isSuccess) {
    toastr.error("Error while calling the api endpoint");
  }

  return { ...state };
}
